module.exports = __webpack_public_path__ + "img/select_all.af7088ee.svg";